
import { computed, defineComponent, ref } from 'vue';
import LiveCard from './LiveCard.vue';
import breakpoints from '../utils/breakpoints';

import { http } from '../services';
import { RaceModel } from '../../../common';
import { Info as InfoIcon, ChevronLeft as CarouselPrev, ChevronRight as CarouselNext } from '@vicons/fa';

export default defineComponent({
  name: 'Live',
  components: { LiveCard, InfoIcon, CarouselPrev, CarouselNext },
  setup () {
    const races = ref<any[]>([]);
    const racesCount = ref(0);
    const cardSpan = computed(() => {
      if (breakpoints.xs.matches || breakpoints.s.matches) return 12;
      if (breakpoints.l.matches || breakpoints.m.matches) return 6;
      return 4;
    });
    const cardsPerSlide = computed(() => 12/cardSpan.value);
    const totalSlides = computed(() => Math.ceil(racesCount.value / cardsPerSlide.value));
    const slideRaces = computed(() => {
      const slideAux: RaceModel[][] = [];
      for (let i = 0; i < totalSlides.value; i++) {
        slideAux.push([]);
        for (let j = 0; j < cardsPerSlide.value; j++) {
          slideAux[i].push(races.value[cardsPerSlide.value * i + j]);
        }
      }
      return slideAux;
    });

    http.getRaces({
      limit: 12,
      offset: 0,
      orderBy: 'createdAt-DESC',
    }).then(res => {
      races.value = res.data;
      racesCount.value = races.value.length;
    });
    return {
      breakpoints,
      races,
      cardSpan,
      cardsPerSlide,
      totalSlides,
      slideRaces
    };
  }
});
